import script from "./screenDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./screenDialog.vue?vue&type=script&lang=ts&setup=true"

import "./screenDialog.vue?vue&type=style&index=0&id=18d85d98&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18d85d98"]])

export default __exports__